import { NgModule } from '@angular/core';
import { ReportComponent } from "./report.component";
import { EmploymentOverviewModule } from "../../components/employment-overview/employment-overview.module";
import { ReportSummaryModule } from "../../components/report-summary/report-summary.module";
import { ExitDetailsModule } from "../../components/exit-details/exit-details.module";
import { EmployeeFeedbackModule } from "../../components/employee-feedback/employee-feedback.module";
import { FooterModule } from 'src/app/components/footer/footer.module';
import { PreferredRoleModule } from "../../components/preferred-role/preferred-role.module";
import { ScoringVerificationModule } from "../../components/scoring-verification/scoring-verification.module";
import { ManagerRecommendationModule } from "../../components/manager-recommendation/manager-recommendation.module";
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser'
import { SendXrefButtonModule } from "src/app/components/send-xref-button/send-xref-button.module";
import { ButtonModule } from '@xref/xref-lib';


@NgModule({
  declarations: [
    ReportComponent,
  ],
  imports: [
    ReportSummaryModule,
    EmploymentOverviewModule,
    ExitDetailsModule,
    EmployeeFeedbackModule,
    PreferredRoleModule,
    ScoringVerificationModule,
    ManagerRecommendationModule,
    RouterModule,
    SendXrefButtonModule,
    BrowserModule,
    FooterModule,
    ButtonModule
  ]
})
export class ReportModule { }
